<template>
  <div class="loginPage" v-loading="loading" element-loading-text="登录中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
    <div class="content">
      <div>
        <iline></iline>
      </div>
      <div class="login">
        <el-form :model="userInfo" ref="form">
          <h2 class="login-title">仪器智能系统</h2>
          <el-form-item prop="username" class="user_item">
            <el-input v-model="userInfo.username" ref="name" clearable placeholder="请输入您的账号">
              <i slot="prefix" class="el-input__icon iconfont icon-yonghu" />
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="userInfo.password" @keyup.enter.native="getlogin" show-password placeholder="请输入您的密码">
              <i slot="prefix" class="el-input__icon iconfont icon-mima" />
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button v-waves @click="getlogin" data-hover="登录" type="primary">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="line-two">
        <iline></iline>
      </div>
    </div>
    <div class="login-foot">
      <div class="login-middle">
        <img src="~@/assets/images/beian.jpg" />
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602008029" target="blank">粤公网安备 44010602008029号</a>
      </div>
      <div>
        <a href="https://beian.miit.gov.cn/" target="blank">粤ICP备18022606号</a>
      </div>
    </div>
  </div>
</template>

<script>
import { login, getUserInfo } from "@/api/loginApi";
import Iline from "./components/line.vue";

export default {
  components: { Iline },
  data() {
    return {
      loading: false,
      userInfo: {
        username: "",
        password: "",
      },
    };
  },
  mounted() {
    this.$refs.name.focus();
  },
  methods: {
    getlogin() {
      if (this.userInfo.username === "" || this.userInfo.password === "") {
        this.$message.warning("用户名或密码不为空");
        return;
      }
      this.verifySuccess();
    },
    verifySuccess() {
      const _this = this;
      _this.loading = true;
      login(_this.userInfo)
        .then((res) => {
          _this.$store.dispatch("setToken", res.access_token).then(() => {
            getUserInfo().then((res) => {
              if (res.code == 200) {
                const roles = [res.data.sysUser.roleId];
                _this.$message.success("登录成功");

                //超级管理员才能查看公司管理
                if (!roles.includes("1")) {
                  _this.$router.options.routes.forEach((item) => {
                    if (item.name == "sys") {
                      item.hidden = true;
                    }
                  });
                } else {
                  _this.$router.options.routes.forEach((item) => {
                    if (item.name == "sys") {
                      item.hidden = false;
                    }
                  });
                }

                //在线送检模块
                if (res.data.modulePower.openVerify) {
                  _this.$router.options.routes.forEach((item) => {
                    if (item.name == "vertify") {
                      item.hidden = false;
                    }
                    if (item.name == "standard") {
                      item.hidden = false;
                    }
                    if (item.name == "mechanism") {
                      item.hidden = false;
                    }
                  });
                }
                _this.$store.dispatch(
                  "setRouters",
                  _this.$router.options.routes
                );

                _this.$store.dispatch("setUserInfo", res.data.sysUser);
                _this.$store.dispatch("setRoles", roles);
                _this.$store.dispatch("setPermissions", res.data.permissions);
                _this.$store.dispatch("setModules", res.data.modulePower);
                _this.$store.dispatch("setDeptName", res.data.deptName);
                _this.$store.dispatch("setDeptLogo", res.data.deptLogo);
                if(roles.includes("4")){
                  _this.$router.replace({ path: "/devOps" });
                }else {
                  _this.$router.replace({ path: "/guidance" });
                }
              } else {
                _this.$message.error(res.msg);
              }
            });
            _this.loading = false;
          });
        })
        .catch((err) => {
          _this.loading = false;
          // that.$message.error(err.msg || err.message || '服务器连接失败')
        });
    },
  },
};
</script>

<style lang="less" scoped>
.loginPage {
  height: 100%;
  overflow: hidden;
  background: #08264b url("~@/assets/images/loginbg.jpg") no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .content {
    display: flex;
    width: 1300px;
    justify-content: space-between;
    align-items: center;
    .line-two {
      transform: rotate(-180deg);
    }
  }
  .login {
    width: 700px;
    height: 700px;
    background: transparent url("~@/assets/images/loginround.png") center
      no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    .el-form {
      padding: 66px 70px 0 70px;
      background: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .login-title {
        color: #7ec4ff;
        font-size: 44px;
        font-family: 宋体;
        margin-bottom: 66px;
      }
      .el-input,
      .el-button {
        width: 350px;
        height: 48px;
        border-radius: 30px;
      }
      /deep/.el-input:hover {
        color: #7fc4fb;
        /deep/ .el-input__prefix,
        /deep/ input::-webkit-input-placeholder {
          color: #7fc4fb;
        }
      }
      .el-button {
        color: #fff;
        font-size: 16px;
        font-family: "Microsoft YaHei";
        background: linear-gradient(90deg, #1470c3, #103abf 60%);
        border: none;
        overflow: hidden;
        position: relative;
      }
      .loginbtn:after {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        pointer-events: none;
        //设置径向渐变
        background-image: radial-gradient(
          circle,
          #7fc4fb 10%,
          transparent 10.01%
        );
        background-repeat: no-repeat;
        background-position: 50%;
        transform: scale(10, 10);
        opacity: 0;
        transition: transform 0.3s, opacity 0.5s;
      }
      .loginbtn:active:after {
        transform: scale(0, 0);
        opacity: 0.3;
        //设置初始状态
        transition: 0s;
      }
      .animate:hover::before {
        max-width: 100%;
      }
      .animate::before {
        position: absolute;
        top: 34%;
        left: 45.4%;
        font-size: 16px;
        font-family: "Microsoft YaHei";
        overflow: hidden;
        max-width: 0;
        color: #7fc4fb;
        content: attr(data-hover);
        -webkit-transition: max-width 0.5s;
        -moz-transition: max-width 0.5s;
        transition: max-width 0.5s;
      }
      /deep/input {
        border-radius: 30px;
        color: #7fc4fb;
        border: none;
        background-color: rgba(0, 0, 0, 0.4);
      }
      /deep/input::-webkit-input-placeholder {
        color: #8c8c8c;
      }
      /deep/input::-ms-input-placeholder {
        color: #8c8c8c;
      }
      /deep/ .el-input--prefix .el-input__inner {
        padding-left: 78px;
        width: 350px;
        height: 48px;
      }
      /deep/ .el-input__prefix {
        left: 24px;
        font-size: 20px;
        padding: 3px;
      }
      .el-form-item {
        margin-bottom: 28px;
        width: 100%;
        text-align: center;
        & /deep/ .el-form-item__error {
          left: 103px;
          color: #7fc4fb;
        }
      }
    }
  }

  .login-foot {
    margin-bottom: -80px;
    font-size: 14px;
    text-align: center;
    .login-middle {
      margin-bottom: 1rem;
    }
    a {
      color: #7ec4ff;
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue